import { all, call, fork, put, select, takeEvery } from "@redux-saga/core/effects";
import { GET_FOUND, ON_ADD_FOUND } from "../../constants/ActionTypes";
import { getData, postData } from "../../util/DynamicApi";
import { ShowSmallError, ShowSuccess } from "../../util/MessageHelper";
import { AddFoundSuccess, getFoundSuccess, hideFoundLoader } from "../actions/Found";

const getFoundRequest = async (token, pageIndex, searchText) =>
    await getData(token, "Found/GetFound", {

        pageIndex: pageIndex,
        searchText: searchText

    })
        .then((found) => {
            return found;
        })
        .catch((error) => {
            return error.response.data;
        });

export const getToken = ({ auth }) => auth.token;

function* doGetFound({ payload }) {
    let { pageIndex, searchText } = payload;
    try {
        let token = yield select(getToken);
        const found = yield call(getFoundRequest, token, pageIndex, searchText);
        if (found.errorMessage) {

            ShowSmallError(found.errorMessage);
            yield put(hideFoundLoader());
        } else {
            yield put(getFoundSuccess(found.data));
        }
    } catch (error) {
        yield ShowSmallError(error);
    }
}

export function* getFound() {
    yield takeEvery(GET_FOUND, doGetFound);
}
const addFoundRequest = async (token, data) =>
    await postData(token, "Found/AddFound", data.payload)
        .then((found) => {
            return found;
        })
        .catch((error) => {
            return error.response.data;;
        });
function* doAddFound(payload) {
    try {
        let token = yield select(getToken);
        const found = yield call(addFoundRequest, token, payload);
        if (found.errorMessage) {
            ShowSmallError(found.errorMessage);
            yield put(hideFoundLoader());
        } else {
            yield put(AddFoundSuccess());
            ShowSuccess("ثبت یافت شده");
        }
    } catch (error) {
        yield ShowSmallError(error);
    }
}

export function* addFound() {
    yield takeEvery(ON_ADD_FOUND, doAddFound);
}
export default function* rootSaga() {
    yield all([
        fork(getFound),
        fork(addFound)]);
}
